import React from "react";
import ConfigSection from "../../ConfigSection";

const ShiftTimingSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Shift Timing'
      configType='ShiftTiming'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default ShiftTimingSection;
